import Accounts from "pages/accounts/Accounts";
import AccountDetail from "pages/accounts/Details";
import MovementDetail from "pages/accounts/_components/MovementDetail";
import SetAlias from "pages/accounts/_components/SetAlias";
import Administration from "pages/administration/Administration";
import AdministrationMediumSignatureTicket from "pages/administration/medium/tickets/SignatureTicket";
import UserInvite from "pages/administration/UserInvite";
import UserInviteStep2 from "pages/administration/UserInviteStep2";
import UserInviteStep3 from "pages/administration/UserInviteStep3";
import UserInviteStep4 from "pages/administration/UserInviteStep4";
import CommunicationMain from "pages/communications/Main";
import Deposits from "pages/deposits/Deposits";
import DepositDetail from "pages/deposits/Details";
import DepositSetAlias from "pages/deposits/_components/SetAlias";
import Desktop from "pages/desktop/Desktop";
import GeneralConditionEnvironment from "pages/environment/GeneralConditionEnvironment";
import CashAdvanceForm from "pages/forms/customForms/CashAdvanceForm";
import TransactionCustom from "pages/forms/customForms/TransactionCustom";
import TransferForeignForm from "pages/forms/customForms/TransferForeignForm";
import TransferInternalForm from "pages/forms/customForms/TransferInternalForm";
import TransferLocalForm from "pages/forms/customForms/TransferLocalForm";
import ConfirmationModal from "pages/forms/_components/ConfirmationModal/ConfirmationModal";
import CreateBeneficiary from "pages/frequentDestination/CreateBeneficiary";
import DetailModiyDeleteFrequentDestinatio from "pages/frequentDestination/DetailsModifyDeleteFrequentDestination";
import ListBeneficiary from "pages/frequentDestination/ListBeneficiary";
import ViewBeneficiary from "pages/frequentDestination/ViewBeneficiary";
import LoanDetails from "pages/loans/Details";
import Loans from "pages/loans/Loans";
import LoanSetAlias from "pages/loans/_components/SetAlias";
import AuthenticatorHandler from "pages/settings/AuthenticatorHandler";
import ChangeEmail from "pages/settings/ChangeEmail";
import ChangeEmailConfirmation from "pages/settings/ChangeEmailConfirmation";
import ChangeEnvironment from "pages/settings/ChangeEnvironment";
import ChangeLanguage from "pages/settings/ChangeLanguage";
import ChangePassword from "pages/settings/ChangePassword";
import ChangePhone from "pages/settings/ChangePhone";
import ChangePhoneConfirmation from "pages/settings/ChangePhoneConfirmation";
import FingerprintConfiguration from "pages/settings/FingerprintConfiguration";
import FingerprintDeleteConfirmation from "pages/settings/FingerprintDeleteConfirmation";
import LastLogin from "pages/settings/LastLogin";
import MyDevices from "pages/settings/MyDevices";
import NotificationsConfiguration from "pages/settings/NotificationsConfiguration";
import NotificationsConfigurationTransports from "pages/settings/NotificationsConfigurationTransports";
import PushNotifications from "pages/settings/PushNotifications";
import PushNotificationsDeleteConfirmation from "pages/settings/PushNotificationsDeleteConfirmation";
import SetDefaultEnvironment from "pages/settings/SetDefaultEnvironment";
import Settings from "pages/settings/Settings";
// Actualizacion de datos personales
import PersonalDataUpdateStepZeroModal from "pages/settings/personalDataUpdate/PersonalDataUpdateStepZeroModal";
import PersonalDataUpdateStep1 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep1";
import PersonalDataUpdateStep2 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep2";
import PersonalDataUpdateStep3 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep3";
import PersonalDataUpdateStep4 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep4";
import PersonalDataUpdateStep5 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep5";
import PersonalDataUpdateStep6 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep6";
import PersonalDataUpdateStep7 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep7";
import PersonalDataUpdateStep8 from "pages/settings/personalDataUpdate/PersonalDataUpdateStep8";
import personalDataUpdateList from "pages/settings/personalDataUpdate/personalDataUpdateList";
/* Actualizacion de datos empresa
import UpdateCompanyDataStepZeroModal from "pages/settings/companyDataUpdate/UpdateCompanyDataStepZeroModal";
import CompanyDataUpdateStep1 from "pages/settings/companyDataUpdate/CompanyDataUpdateStep1";
import CompanyDataUpdateStep2 from "pages/settings/companyDataUpdate/CompanyDataUpdateStep2";
import CompanyDataUpdateStep3 from "pages/settings/companyDataUpdate/CompanyDataUpdateStep3";
import CompanyDataUpdateStep4 from "pages/settings/companyDataUpdate/CompanyDataUpdateStep4";
import CompanyDataUpdateStep5 from "pages/settings/companyDataUpdate/CompanyDataUpdateStep5";
import companyDataUpdateList from "pages/settings/companyDataUpdate/companyDataUpdateList";
*/
import SoftTokenValidateEntrustCode from "pages/softToken/SoftTokenValidateEntrustCode";
import SoftTokenValidateOtp from "pages/softToken/SoftTokenValidateOtp";
import SessionAboutToExpire from "pages/status/SessionAboutToExpire";
import SessionCLose from "pages/status/SessionCLose";
import TokenActivationFailed from "pages/Token/TokenActivationFailed";
import TokenActivationPending from "pages/Token/TokenActivationPending";
import TokenActivationStep1 from "pages/Token/TokenActivationStep1";
import TokenActivationStep2 from "pages/Token/TokenActivationStep2";
import TokenActivationSuccess from "pages/Token/TokenActivationSuccess";
import PendingTransactionList from "pages/transactions/PendingTransactionList";
import TransactionsList from "pages/transactions/TransactionsList";
import TransactionsListHistoric from "pages/transactions/TransactionsListHistoric";
import BackButtonListener from "pages/_components/BackButtonListener";
import { resizableRoute } from "pages/_components/Resizable";
import TermsAndConditions from "pages/_components/TermsAndConditions";
import DashboardLayout from "pages/_layouts/DashboardLayout";
import DefaultLayout from "pages/_layouts/DefaultLayout";
import { bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { selectors as sessionSelectors } from "reducers/session";
import CreateTokenPinForm from "pages/forms/customForms/CreateTokenPinForm";
import { actions as statusActions } from "reducers/status";
import ScheduledTransactionsMigration from "pages/ScheduledTransactionsMigration";
import Checks from "pages/checks/Checks";
import StopChecksForm from "pages/forms/customForms/StopChecksForm";
import InstallmentPurchaseForm from "pages/forms/customForms/InstallmentPurchaseForm";
import AccountRequestModal from "pages/_components/modal/AccountRequestModal";
import TokenActivationAttemps from "pages/Token/TokenActivationAttemps";
import TokenActivationFailedDocument from "pages/Token/TokenActivationFailedDocument";
import ReportReplaceCard from "pages/forms/customForms/ReportReplaceCard";
// import DefaultCorporateStepperLayout from "pages/_layouts/DefaultStepperLayout/DefaultCorporateStepperLayout";
import DefaultStepperLayout from "pages/_layouts/DefaultStepperLayout/DefaultStepperLayout";
import MultipleSignaturesConfirm from "pages/transactions/_components/MultipleSignaturesConfirm";

// import UiComponents from "pages/UiComponents";

// BORRAR?
// import RequestLoanForm from "pages/forms/customForms/RequestLoanForm";
// MVP2
// import AccountOpeningRequestForm from "pages/forms/customForms/AccountOpeningRequestForm";

// EMPRESAS PAGO DE SUELDO
// import TransactionPaymentLines from "pages/forms/TransactionPaymentLines";
// EMPRESAS?
// import Templates from "pages/forms/_components/Templates";
// import BankSearch from "pages/forms/_components/_fields/_bankselector/bankSearch/BankSearch";
// import BankSearchCustom from "pages/forms/_components/_fields/_bankselector/bankSearch/BankSearchCustom";

// PATHS ELIMINADOS PARTE 1 (PARA PRODUCTO)
/* import Filters from "pages/accounts/_components/MobileFilters";
import Results from "pages/accounts/_components/MobileFiltersResults";
import MobileTransfers from "pages/accounts/_components/MobileTransfers";
import AccountStatements from "pages/accounts/_components/Statements";
import CreditCardAliasForm from "pages/creditCards/EditAlias";
import CreditCardMobileFilterResult from "pages/creditCards/MobileFilterResult";
import CreditCardMobileFilters from "pages/creditCards/MobileFilters";
import DepositStatements from "pages/deposits/_components/Statements";
import CreateDepositForm from "pages/forms/customForms/CreateDepositForm";
import CreditCardPaymentForm from "pages/forms/customForms/CreditCardPaymentForm";
import TransferPeerToPeerForm from "pages/forms/customForms/TransferPeerToPeerForm";
import Form from "pages/forms/Form";
import FormPaymentLines from "pages/forms/FormPaymentLines";
import LoanMobileFilters from "pages/loans/_components/MobileFilters";
import LoanStatementDetail from "pages/loans/_components/StatementDetail";
import PointsOfInterest from "pages/pointsOfInterest";
import AddServicePaymentForm from "pages/servicePaymentsOld/AddServicePaymentForm";
import DeleteServicePaymentForm from "pages/servicePaymentsOld/DeleteServicePaymentForm";
import ModifyServicePaymentForm from "pages/servicePaymentsOld/ModifyServicePaymentForm";
import PayServiceHistoryList from "pages/servicePaymentsOld/PayServiceHistoryList";
import PayServiceList from "pages/servicePaymentsOld/PayServiceList";
import ChangeAddresses from "pages/settings/ChangeAddresses";
import ChangeSecuritySeal from "pages/settings/ChangeSecuritySeal";
import ChangeSecuritySealConfirmation from "pages/settings/ChangeSecuritySealConfirmation";
import DocumentsIndex from "pages/settings/_esign/DocumentsIndex";
import EsignDocumentsSigned from "pages/settings/_esign/EsignDocumentsSigned";
import PaperlessModify from "pages/settings/_paperless/PaperlessModify";
import TransactionsListFilters from "pages/transactions/_components/MobileFilters";
import TransactionsFiltersResults from "pages/transactions/_components/MobileFiltersResults"; */
// END PATHS ELIMINADOS PARTE 1 (PARA PRODUCTO)

class PrivateRoutes extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        hasActiveSession: bool,
        location: shape({
            pathname: string,
        }).isRequired,
        isMobileNative: bool.isRequired,
    };

    static defaultProps = {
        hasActiveSession: false,
    };

    componentDidMount() {
        const { dispatch, location } = this.props;
        dispatch(statusActions.saveLastHref(location));
    }

    render() {
        const { hasActiveSession, isMobileNative } = this.props;

        if (!hasActiveSession) {
            return <Redirect to="/" />;
        }

        const mobileRoutes = isMobileNative ? (
            <Switch>
                <DefaultLayout
                    path="/auth/tokenActivationAttemps"
                    noBar
                    component={TokenActivationAttemps}
                    transition="transition-drill-in"
                    componentProps={{
                        showDocumentButton: "1",
                    }}
                />
                <DefaultLayout
                    path="/auth/tokenActivationFailedDocument"
                    noBar
                    component={TokenActivationFailedDocument}
                    transition="transition-drill-in"
                    componentProps={{
                        showDocumentButton: "1",
                    }}
                />
                <Redirect from="*" to="/desktop" />
            </Switch>
        ) : null;

        return (
            <>
                <Switch>
                    <DashboardLayout scrollable dashboard exact path="/desktop" component={Desktop} />
                    <DashboardLayout scrollable dashboard exact path="/desktop/:id" component={Desktop} />

                    <DefaultLayout
                        exact
                        path="/formCustom/cashAdvance"
                        component={CashAdvanceForm}
                        transition="transition-flow-open"
                        permissions={["cashAdvance"]}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/reportReplaceCard/:id"
                        component={ReportReplaceCard}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                        permissions={["creditCards.report"]}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/renewCard/:id"
                        component={ReportReplaceCard}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                        permissions={["creditCards.report"]}
                        noBar
                    />

                    {/* ACCOUNTS */}
                    <DefaultLayout exact path="/accounts" component={Accounts} />

                    {/* NO BORRAR MVP2 */}
                    {/* <DefaultLayout
                        exact
                        path="/accounts/openingRequest"
                        component={AccountOpeningRequestForm}
                        permissions={["accountOpen"]}
                    /> */}
                    {/* END NO BORRAR MVP2 */}

                    <DefaultLayout
                        exact
                        path="/accounts/:id"
                        component={AccountDetail}
                        transition="transition-drill-in"
                        defaultValidationPosition={false}
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/movement"
                        component={MovementDetail}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/setAlias"
                        component={SetAlias}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                    />

                    {/* CHECKS */}

                    <DefaultLayout
                        exact
                        path="/checks/:idProduct/:idCheckbook"
                        component={Checks}
                        defaultValidationPosition={false}
                    />
                    <DefaultLayout exact path="/formCustom/stopChecks" component={StopChecksForm} />
                    <DefaultLayout exact path="/formCustom/stopCheckbooks" component={StopChecksForm} />
                    <DefaultLayout
                        exact
                        path="/searchchecks/:idProduct"
                        component={Checks}
                        defaultValidationPosition={false}
                    />
                    {/* DEPOSITS */}
                    <DefaultLayout exact path="/deposits" component={Deposits} />
                    <DefaultLayout
                        exact
                        path="/deposits/:id"
                        component={DepositDetail}
                        transition="transition-drill-in"
                        defaultValidationPosition={false}
                    />
                    <DefaultLayout
                        exact
                        path="/deposits/:id/setAlias"
                        component={DepositSetAlias}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                    />

                    <DefaultLayout exact path="/settings" component={Settings} noBar />
                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep1"
                        stepsList={personalDataUpdateList}
                        step={1}
                        completed={0}
                        component={PersonalDataUpdateStep1}
                        noBar
                        customBackURL="/desktop"
                    />

                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep2"
                        stepsList={personalDataUpdateList}
                        step={2}
                        completed={1}
                        component={PersonalDataUpdateStep2}
                        noBar
                        customBackURL="/desktop"
                    />

                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep3"
                        stepsList={personalDataUpdateList}
                        step={3}
                        completed={2}
                        component={PersonalDataUpdateStep3}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep4"
                        stepsList={personalDataUpdateList}
                        step={4}
                        completed={3}
                        component={PersonalDataUpdateStep4}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep5"
                        stepsList={personalDataUpdateList}
                        step={5}
                        completed={4}
                        component={PersonalDataUpdateStep5}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep6"
                        stepsList={personalDataUpdateList}
                        step={6}
                        completed={5}
                        component={PersonalDataUpdateStep6}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep7"
                        stepsList={personalDataUpdateList}
                        step={6}
                        completed={6}
                        component={PersonalDataUpdateStep7}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultStepperLayout
                        exact
                        title="settings.options.updateUserData"
                        path="/settings/personalDataUpdateStep8"
                        stepsList={personalDataUpdateList}
                        step={6}
                        completed={6}
                        component={PersonalDataUpdateStep8}
                        noBar
                        customBackURL="/desktop"
                    />

                    {/* COMPANY DATA UPDATE */}
                    {/* <DefaultCorporateStepperLayout
                        exact
                        title="administration.companyDataUpdate.title"
                        path="/companyDataUpdateStep1"
                        stepsList={companyDataUpdateList}
                        step={1}
                        completed={0}
                        component={CompanyDataUpdateStep1}
                        noBar
                        customBackURL="/desktop"
                    />

                    <DefaultCorporateStepperLayout
                        exact
                        title="administration.companyDataUpdate.title"
                        path="/companyDataUpdateStep2"
                        stepsList={companyDataUpdateList}
                        step={2}
                        completed={1}
                        component={CompanyDataUpdateStep2}
                        noBar
                        customBackURL="/desktop"
                    />

                    <DefaultCorporateStepperLayout
                        exact
                        title="administration.companyDataUpdate.title"
                        path="/companyDataUpdateStep3"
                        stepsList={companyDataUpdateList}
                        step={3}
                        completed={2}
                        component={CompanyDataUpdateStep3}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultCorporateStepperLayout
                        exact
                        title="administration.companyDataUpdate.title"
                        path="/companyDataUpdateStep4"
                        stepsList={companyDataUpdateList}
                        step={4}
                        completed={3}
                        component={CompanyDataUpdateStep4}
                        noBar
                        customBackURL="/desktop"
                    />
                    <DefaultCorporateStepperLayout
                        exact
                        title="administration.companyDataUpdate.title"
                        path="/companyDataUpdateStep5"
                        stepsList={companyDataUpdateList}
                        step={4}
                        completed={4}
                        component={CompanyDataUpdateStep5}
                        noBar
                        customBackURL="/desktop"
                    /> */}

                    {/* END - COMPANY DATA UPDATE  */}

                    <DefaultLayout
                        exact
                        path="/settings/changePassword"
                        component={ChangePassword}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/notificationsConfiguration"
                        component={NotificationsConfiguration}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        path="/settings/notificationsConfiguration/:communicationType"
                        component={NotificationsConfigurationTransports}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/fingerprintConfiguration"
                        component={FingerprintConfiguration}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/fingerprintConfiguration/deleteConfirmation"
                        component={FingerprintDeleteConfirmation}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/pushNotifications"
                        component={PushNotifications}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/myDevices"
                        component={MyDevices}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/pushNotifications/deleteConfirmation"
                        component={PushNotificationsDeleteConfirmation}
                        noBar
                    />

                    {/* MEJORAR UI */}
                    <DefaultLayout
                        exact
                        path="/settings/changeEnvironment"
                        component={ChangeEnvironment}
                        transition="transition-flow-open"
                        noBar
                    />

                    {/* MEJORAR UI */}
                    <DefaultLayout
                        exact
                        path="/settings/setDefaultEnvironment"
                        component={SetDefaultEnvironment}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeLanguage"
                        component={ChangeLanguage}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeEmail"
                        component={ChangeEmail}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeEmail/confirmation"
                        component={ChangeEmailConfirmation}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changePhone"
                        component={ChangePhone}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changePhone/confirmation"
                        component={ChangePhoneConfirmation}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/authenticatorHandler"
                        component={AuthenticatorHandler}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout exact path="/settings/LastLogin" component={LastLogin} noBar />

                    {/* SETTINGS TOKEN */}

                    <DefaultLayout
                        path="/authenticateSofttoken"
                        noBar
                        component={SoftTokenValidateOtp}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        path="/migrateSoftTokenEntrust"
                        noBar
                        component={SoftTokenValidateEntrustCode}
                        transition="transition-drill-in"
                        componentProps={{
                            title: "softtoken.validation.migrate.entrust.title.label",
                            description: "softtoken.validation.migrate.entrust.description.label",
                        }}
                    />
                    <DefaultLayout
                        path="/migrateSoftTokenLocal"
                        noBar
                        component={SoftTokenValidateEntrustCode}
                        transition="transition-drill-in"
                        componentProps={{
                            title: "softtoken.validation.migrate.local.title.label",
                            description: "softtoken.validation.migrate.local.description.label",
                        }}
                    />
                    <DefaultLayout
                        path="/createTokenPinForm"
                        noBar
                        component={CreateTokenPinForm}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationStep1"
                        noBar
                        exact
                        component={TokenActivationStep1}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationStep1RedirectSession"
                        noBar
                        exact
                        component={TokenActivationStep1}
                        transition="transition-drill-in"
                        componentProps={{
                            pathGoBack: "/desktop",
                        }}
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationStep2"
                        noBar
                        component={TokenActivationStep2}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationPending"
                        noBar
                        component={TokenActivationPending}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationPendingSecondary"
                        noBar
                        component={TokenActivationPending}
                        transition="transition-drill-in"
                        componentProps={{
                            isSecondary: true,
                        }}
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationSuccess"
                        noBar
                        component={TokenActivationSuccess}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        path="/auth/tokenActivationFailed"
                        noBar
                        component={TokenActivationFailed}
                        transition="transition-drill-in"
                        componentProps={{
                            showDocumentButton: "1",
                        }}
                    />
                    <DefaultLayout
                        path="/auth/tokenEntrustActivationFailed"
                        noBar
                        component={TokenActivationFailed}
                        transition="transition-drill-in"
                        componentProps={{
                            showDocumentButton: "0",
                        }}
                    />

                    {/* LOANS */}
                    <DefaultLayout exact path="/loans" component={Loans} />
                    <DefaultLayout
                        exact
                        path="/loans/:id/"
                        component={LoanDetails}
                        transition="transition-drill-in"
                        defaultValidationPosition={false}
                    />
                    <DefaultLayout
                        exact
                        path="/loans/:id/setAlias"
                        component={LoanSetAlias}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                    />

                    {/* Borrar ? */}
                    {/* <DefaultLayout path="/loansPayment/request" component={RequestLoanForm} /> */}

                    {/* FORMS */}
                    <DefaultLayout
                        exact
                        path="/formCustom/transferInternal"
                        component={TransferInternalForm}
                        permissions={["transferInternal"]}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/transferLocal"
                        component={TransferLocalForm}
                        permissions={["transferLocal", "transferThirdParties"]}
                        somePermissions
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/transferForeign"
                        component={TransferForeignForm}
                        permissions={["transferForeign"]}
                        noBar
                    />

                    <DefaultLayout exact path="/formCustom/installmentPurchase" component={InstallmentPurchaseForm} />

                    {/* COMMUNICATIONS */}
                    <DefaultLayout
                        exact
                        path="/communications"
                        component={CommunicationMain}
                        noBar
                        scrollable={false}
                    />

                    {/* TRANSACTIONS */}
                    <DefaultLayout exact path="/transactions/list" component={TransactionsList} noBar />
                    <DefaultLayout
                        exact
                        path="/transactions/list/historic"
                        component={TransactionsListHistoric}
                        noBar
                    />
                    <DefaultLayout exact path="/pendingTransaction/list" component={PendingTransactionList} noBar />
                    <DefaultLayout
                        exact
                        path="/pendingTransaction/list/multipleSignatureConfirmation"
                        component={MultipleSignaturesConfirm}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/pendingTransaction/list/multipleSignatureDelete"
                        component={MultipleSignaturesConfirm}
                        noBar
                        isDeleteMode
                    />
                    <DefaultLayout
                        path="/transaction/:idTransaction"
                        component={TransactionCustom}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                        exact
                        noBar
                    />
                    <DefaultLayout
                        path="/transaction/historic/:idTransaction"
                        component={TransactionCustom}
                        transition="transition-flow-open"
                        defaultValidationPosition={false}
                        exact
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/transactions/scheduled/migrate"
                        component={ScheduledTransactionsMigration}
                        noBar
                    />

                    {/* EMPRESAS PAGO DE SUELDO */}
                    {/* <DefaultLayout
                        path="/transaction/:idTransaction/processDetail"
                        component={TransactionPaymentLines}
                        transition="transition-drill-in"
                    />

                    {/* EMPRESAS? */}
                    {/* <DefaultLayout path="/form/:formId/bankSearch/:fieldId" component={BankSearch} /> */}
                    {/* <DefaultLayout path="/form/:formId/templates" component={Templates} /> */}
                    {/* END EMPRESAS? */}

                    {/* EXTERNAL */}
                    <DefaultLayout exact path="/termsAndConditions" component={TermsAndConditions} />

                    {/* administration */}
                    <DefaultLayout exact path="/administration/users/invite" component={UserInvite} />
                    <DefaultLayout exact path="/administration/users/inviteStep2" component={UserInviteStep2} />
                    <DefaultLayout exact path="/administration/users/inviteStep3" component={UserInviteStep3} />
                    <DefaultLayout exact path="/administration/users/inviteStep4" component={UserInviteStep4} />
                    <DefaultLayout
                        exact
                        path="/administration/medium/signature/:idTransaction/ticket"
                        component={AdministrationMediumSignatureTicket}
                        defaultValidationPosition={false}
                    />
                    <DefaultLayout path="/administration" component={Administration} isAdminComponentRoute />
                    {/* end of administration */}

                    {/* beneficiary */}
                    <DefaultLayout
                        exact
                        path="/frequentDestination"
                        component={ListBeneficiary}
                        permissions={["beneficiaryManage"]}
                        noBar
                    />
                    <DefaultLayout exact path="/createFrequentDestination" component={CreateBeneficiary} noBar />
                    <DefaultLayout
                        exact
                        path="/viewFrequentDestination/:idBeneficiary"
                        component={ViewBeneficiary}
                        defaultValidationPosition={false}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/editFrequentDestination/:beneficiaryId/:type"
                        component={CreateBeneficiary}
                        defaultValidationPosition={false}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/detailModifyDeleteFrequentDestination"
                        component={DetailModiyDeleteFrequentDestinatio}
                        noBar
                    />
                    {/* end of beneficiary */}

                    {/* EMPRESAS? */}
                    {/* <DefaultLayout
                        path="/detailModifyDeleteFrequentDestination/bankSearch/:fieldId"
                        component={BankSearchCustom}
                    /> */}

                    <DefaultLayout exact path="/envGeneralConditions" component={GeneralConditionEnvironment} />

                    {/* For develop */}
                    {/* <DefaultLayout path="/ui-components" component={UiComponents} /> */}

                    {mobileRoutes}

                    {/* PATHS ELIMINADOS PARTE 1 (PARA PRODUCTO)
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/alias"
                        component={CreditCardAliasForm}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/filters"
                        component={CreditCardMobileFilters}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/filters/results"
                        component={CreditCardMobileFilterResult}
                    />
                    <DefaultLayout exact path="/accounts/:id/statements" component={AccountStatements} />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/filters"
                        component={Filters}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/accounts/:id/filters/results" component={Results} />
                    <DefaultLayout exact path="/accounts/:id/transfers" component={MobileTransfers} />
                    <DefaultLayout exact path="/deposits/:id/statements" component={DepositStatements} />
                    <DefaultLayout
                        exact
                        path="/deposits/:id/filters"
                        component={Filters}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/deposits/:id/filters/results" component={Results} />
                    <DefaultLayout
                        exact
                        path="/formCustom/createDeposit"
                        component={CreateDepositForm}
                        permissions={["depositCreate"]}
                        noBar
                    />
                    {// SERVICE PAYMENTS OLD }
                    <DefaultLayout
                        exact
                        path="/servicePayments/list"
                        component={PayServiceList}
                        permissions={["servicePayment"]}
                    />
                    <DefaultLayout
                        exact
                        path="/servicePaymentsHistory/list/:idServicePayment"
                        component={PayServiceHistoryList}
                        permissions={["servicePayment"]}
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/addServicePayment"
                        component={AddServicePaymentForm}
                        permissions={["servicePayment"]}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/modifyServicePayment/:idServicePayment"
                        component={ModifyServicePaymentForm}
                        permissions={["servicePayment"]}
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/formCustom/deleteServicePayment/:idServicePayment"
                        component={DeleteServicePaymentForm}
                        permissions={["servicePayment"]}
                        noBar
                    />

                    <DefaultLayout
                        exact
                        path="/settings/changeSecuritySeal"
                        component={ChangeSecuritySeal}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeSecuritySeal/confirmation"
                        component={ChangeSecuritySealConfirmation}
                        noBar
                    />

                    <DefaultLayout
                        exact
                        path="/settings/esign/documents"
                        component={DocumentsIndex}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/esign/documentsSigned"
                        component={EsignDocumentsSigned}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/paperless/edit"
                        component={PaperlessModify}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout
                        exact
                        path="/settings/ChangeAddresses"
                        component={ChangeAddresses}
                        transition="transition-flow-open"
                        noBar
                    />
                    <DefaultLayout exact path="/settings/pointsOfInterest" component={PointsOfInterest} noBar />

                    {// MANUAL MASS PAYMENT }
                    <DefaultLayout
                        path="/form/:idForm/manual"
                        component={FormPaymentLines}
                        transition="transition-drill-in"
                    />

                    <DefaultLayout
                        path="/form/:idForm/processDetail"
                        component={FormPaymentLines}
                        transition="transition-drill-in"
                        componentProps={{ isConfirmation: true }}
                    />
                    <DefaultLayout
                        exact
                        path="/transactions/list/filters"
                        component={TransactionsListFilters}
                        transition="transition-flow-open"
                    />

                    <DefaultLayout
                        exact
                        path="/transactions/list/filters/results"
                        transition="transition-flow-open"
                        component={TransactionsFiltersResults}
                    />
                    <DefaultLayout exact path="/form/:idForm" component={Form} transition="transition-flow-open" />
                    <DefaultLayout
                        exact
                        path="/formCustom/transferPeerToPeer"
                        component={TransferPeerToPeerForm}
                        permissions={["transferPeerToPeer"]}
                        noBar
                    />
                    <DefaultLayout
                        path="/creditCardsPayment/list"
                        component={CreditCardPaymentForm}
                        permissions={["payCreditCard", "payCreditCardThird", "payCreditCardOther"]}
                        somePermissions
                    />
                    <DefaultLayout
                        exact
                        path="/loans/:id/statement"
                        component={LoanStatementDetail}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/loans/:id/filters"
                        component={LoanMobileFilters}
                        transition="transition-flow-open"
                    />
                    { END PATHS ELIMINADOS PARTE 1 (PARA PRODUCTO) */}
                    <Redirect from="*" to="/desktop" />
                </Switch>
                <BackButtonListener />

                <Route path="/" component={PersonalDataUpdateStepZeroModal} />
                <Route path="/" component={SessionAboutToExpire} />
                <Route path="/" component={SessionCLose} />
                <Route path="/" component={AccountRequestModal} />
                {/* <Route path="/" component={UpdateCompanyDataStepZeroModal} /> */}
                <Route path="/" component={ConfirmationModal} />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
});

export default withRouter(connect(mapStateToProps)(resizableRoute(PrivateRoutes)));
